// https://gist.github.com/joelambert/1002116

const requestAnimFrame: (callback: FrameRequestCallback) => number =
  window.requestAnimationFrame ??
  ((callback: FrameRequestCallback): number => window.setTimeout(callback, 1000 / 60));

export type IntervalID = { value: number };

export const requestInterval = (callback: () => void, delay: number): IntervalID => {
  if (!window.requestAnimationFrame) return { value: window.setInterval(callback, delay) };

  let start = Date.now();
  const handle: IntervalID = { value: -1 };

  const loop = (): void => {
    const current = Date.now();
    const delta = current - start;

    if (delta >= delay) {
      callback();
      start = Date.now();
    }

    handle.value = requestAnimFrame(loop);
  };

  handle.value = requestAnimFrame(loop);
  return handle;
};

export const clearRequestInterval = (handle?: IntervalID | null): void => {
  if (!handle) return;
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(handle.value);
    return;
  }
  window.clearInterval(handle.value);
};
